import { gql } from '@urql/core';

export const CREATE_FILE_UPLOAD_MUTATION = gql`
    mutation CreateFileUploadMutation($input: CreateFileUploadInput!) {
        createFileUpload(input: $input) {
            url
            fields {
                key
                value
            }
            uploadToken
        }
    }
`;

export const CREATE_STRUCTURE_MUTATION = gql`
    mutation CreateStructureMutation($input: CreateStructureInput!) {
        createStructure(input: $input) {
            structure {
                id
            }
        }
    }
`;

export const COPY_STRUCTURES_MUTATION = gql`
    mutation CopyStructures($input: CopyStructureInput!) {
        copyStructures(input: $input) {
            success
        }
    }
`;

export const UPDATE_STRUCTURE_MUTATION = gql`
    mutation UpdateStructureMutation($input: UpdateStructureInput!) {
        updateStructure(input: $input) {
            structure {
                id
            }
        }
    }
`;

export const DELETE_STRUCTURE_MUTATION = gql`
    mutation DeleteStructureMutation($input: DeleteStructureInput!) {
        deleteStructure(input: $input) {
            success
        }
    }
`;

export const CREATE_STRUCTURE_REFERENCE_MUTATION = gql`
    mutation CreateStructureReferences($input: CreateReferencesToStructureInput!) {
        createStructureReferences(input: $input) {
            success
        }
    }
`;

export const ADD_USER_TO_STRUCTURE = gql`
    mutation AddUserToStructureMutation($input: AddUserToStructureInput!) {
        addUserToStructure(input: $input) {
            success
        }
    }
`;

export const ADD_ORGANIZATION_TO_STRUCTURE = gql`
    mutation AddOrganizationToStructureMutation($input: AddOrganizationToStructureInput!) {
        addOrganizationToStructure(input: $input) {
            success
        }
    }
`;

export const REMOVE_ORGANIZATION_FROM_STRUCTURE = gql`
    mutation RemoveOrganizationFromStructure($input: RemoveOrganizationFromStructureInput!) {
        removeOrganizationFromStructure(input: $input) {
            success
        }
    }
`;

export const REMOVE_USER_FROM_STRUCTURE = gql`
    mutation RemoveUserFromStructure($input: RemoveUserFromStructureInput!) {
        removeUserFromStructure(input: $input) {
            success
        }
    }
`;

export const UPDATE_STRUCTURE_FILE = gql`
    mutation UpdateStructureFilesMutation($input: UpdateStructureFilesInput!) {
        updateStructureFiles(input: $input) {
            structure {
                id
            }
        }
    }
`;

export const UPDATE_FINISHING_SCHEME = gql`
    mutation UpdateFile($input: UpdateStructureFinishingSchemeInput!) {
        updateStructureFinishingScheme(input: $input) {
            structure {
                id
            }
        }
    }
`;

export const CREATE_STOREY_MUTATION = gql`
    mutation CreateStructureMutation($input: CreateStructureInput!) {
        createStructure(input: $input) {
            structure {
                id
            }
        }
    }
`;

export const DELETE_STRUCTURE_REVISION_MUTATION = gql`
    mutation DeleteStructureRevisionMutation($input: DeleteStructureRevisionInput!) {
        deleteStructureRevision(input: $input) {
            success
        }
    }
`;

export const CREATE_STRUCTURE_REVISION_MUTATION = gql`
    mutation CreateStructureRevisionMutation($input: CreateStructureRevisionInput!) {
        createStructureRevision(input: $input) {
            structureRevision {
                id
            }
        }
    }
`;

export const UPDATE_STRUCTURE_REVISION_MUTATION = gql`
    mutation UpdateStructureRevision($input: UpdateStructureRevisionInput!) {
        updateStructureRevision(input: $input) {
            structureRevision {
                id
            }
        }
    }
`;

export const DELETE_SUBTREE_STRUCTURES_MUTATION = gql`
    mutation DeleteSubtreeStructures($input: DeleteSubtreeStructuresInput!) {
        deleteSubtreeStructures(input: $input) {
            success
        }
    }
`;

export const SWAP_STRUCTURE_FILE_MUTATION = gql`
    mutation SwapStructureFile($input: SwapStructureFileInput!) {
        swapStructureFile(input: $input) {
            structure {
                id
            }
        }
    }
`;

export const DELETE_STRUCTURE_FILES_MUTATION = gql`
    mutation DeleteStructureFiles($input: DeleteStructureFilesInput!) {
        deleteStructureFiles(input: $input) {
            structure {
                id
            }
        }
    }
`;

export const CREATE_STRUCTURE_VECTOR_STORE_MUTATION = gql`
    mutation CreateStructureVectorStore($structureId: ID!) {
        createStructureVectorStore(structureId: $structureId) {
            id
            vectorStoreId
            vectorStoreCreatedAt
        }
    }
`;

export const BATCH_INDEX_EXISTING_FILES_MUTATION = gql`
    mutation BatchIndexExistingFiles($structureId: ID) {
        batchIndexExistingFiles(structureId: $structureId) {
            totalFiles
            queuedFiles
            alreadyIndexed
            errors
        }
    }
`;
